import { Typography } from '@libs/components';
import styled from 'styled-components';

export const EditContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.surface.buttonBackground};
  height: 12.4rem;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  padding: 1.6rem 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.x3};
`;

export const EditInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-bottom: 1.6rem;
  margin-top: 2rem;
`;

export const CustomTypography = styled(Typography)`
  word-break: break-word;
`;
